import { atom } from "jotai";

interface NotiPaginationState {
  total: number;
  totalPage: number;
  currentPage: number;
  limit: number;
  isLoadMore: boolean;
}

export const notiPaginationAtom = atom<NotiPaginationState>({
  total: 0,
  totalPage: 0,
  currentPage: 1,
  limit: 10,
  get isLoadMore() {
    return this.currentPage <= this.totalPage;
  },
});

const notiPaginationDerivedAtom = atom(
  (get) => get(notiPaginationAtom),
  (get, set, newValue: Partial<NotiPaginationState>) => {
    const currentValue = get(notiPaginationAtom);
    const merged = {
      ...currentValue,
      ...newValue,
    };

    merged.isLoadMore = merged.currentPage <= merged.totalPage;

    set(notiPaginationAtom, merged);
  }
);

export default notiPaginationDerivedAtom;